import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import RelatorioAlunoBimestreForm from "./RelatorioAlunoBimestreForm";
import RltTurmaForm from "./RltTurmaForm";
import RltTDPBimestreForm from "./RltTDPBimestreForm";
import RltTDPForm from "./RltTDPForm";
import Grid from "@mui/material/Grid";
import RltTurmaBimestreForm from "./RltTurmaBimestreForm";
import ProgressLog from "../../shared/components/ProgressLog/ProgressLogForm";
import { findByServico } from "../../shared/components/ProgressLog/api-progress-log";
import { useSelector, useDispatch } from "react-redux";
import { setProgressLog } from "../../shared/components/ProgressLog/actions/actions";
import { findByAnoLetivo } from "../Turma/api-turma";
import { findByCurrentUser } from "../TDP/api-tdp";
import RltAnoLetivoForm from "./RltAnoLetivoForm";
import RelatorioAlunoForm from "./RelatorioAlunoForm";
import RelatorioAlunoTdpForm from "./RelatorioAlunoTdpForm";
import RltAvancado from "./RltAvancado";

const useStyles = makeStyles({
  paper: {
    padding: "20px",
  },
  title: {
    marginBottom: "20px",
  },
  adicionarDisciplina: {
    paddingBottom: "10px",
  },
  formControl: {
    marginBottom: "10px",
  },
});

export default function RelatorioContainer() {
  const classes = useStyles();
  const progressLog = useSelector((state) => state.progressLog);
  const [turmas, setTurmas] = useState([]);
  const [tdps, setTdps] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    findByAnoLetivo().then((data) => {
      if (data.error) {
        console.log(data);
      } else {
        setTurmas(data);
      }
    });
    findByCurrentUser().then((data) => {
      if (data.error) {
        console.log(data);
      } else {
        setTdps(data);
      }
    });
  }, []);

  useEffect(() => {
    findByServico("relatorio").then((data) => {
      if (data) {
        dispatch(setProgressLog(data));
      }
    });
  }, [dispatch]);

  useEffect(() => {
    while (progressLog) {
      const timer = setTimeout(() => {
        findByServico("relatorio").then((data) => {
          if (data) {
            dispatch(setProgressLog(data));
          }
        });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [dispatch, progressLog]);

  return (
    <div>
      <Container className={classes.paper}>
        <Typography className={classes.title} variant="h6">
          Relatório
        </Typography>
        <Grid container spacing={3}>
          {progressLog && progressLog.servico === "relatorio" ? (
            <Grid size={12}>
              <ProgressLog />
            </Grid>
          ) : (
            <>
              <Grid size={6}>
                <RelatorioAlunoForm turmas={turmas} />
              </Grid>
              <Grid size={6}>
                <RelatorioAlunoBimestreForm turmas={turmas} />
              </Grid>
              <Grid size={6}>
                <RelatorioAlunoTdpForm turmas={turmas} />
              </Grid>
              <Grid size={6}>
                <RltTurmaForm turmas={turmas} />
              </Grid>
              <Grid size={6}>
                <RltTurmaBimestreForm turmas={turmas} />
              </Grid>
              <Grid size={6}>
                <RltTDPForm tdps={tdps} />
              </Grid>
              <Grid size={6}>
                <RltTDPBimestreForm tdps={tdps} />
              </Grid>

              <Grid size={6}>
                <RltAnoLetivoForm />
              </Grid>
              <Grid size={6}>
                <RltAvancado />
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </div>
  );
}
